import React from "react";
import { DocumentAttachmentDetailDto } from "apis/data-contracts";
import CreateDocumentFormField from "components/document/Create/CreateDocumentForm/CreateDocumentFormField";
import AttachmentItem from "components/foundation/AttachmentItem/AttachmentItem";
import CardLayout from "components/foundation/templates/CardLayout";
import styled from "styled-components";

export interface DocumentDetailAttachmentListProps {
  attachmentList: DocumentAttachmentDetailDto[];
  withoutCard?: boolean;
  approvedDocument?: boolean;
}

const DocumentDetailAttachmentList = ({
  attachmentList,
  withoutCard,
  approvedDocument,
}: DocumentDetailAttachmentListProps) => {
  return withoutCard ? (
    <div>
      <AttachmentList
        attachmentList={attachmentList}
        approvedDocument={approvedDocument}
      />
    </div>
  ) : (
    <CardLayout.Container>
      <AttachmentList
        attachmentList={attachmentList}
        approvedDocument={approvedDocument}
      />
    </CardLayout.Container>
  );
};

interface AttachmentListProps {
  attachmentList: DocumentAttachmentDetailDto[];
  approvedDocument?: boolean;
}

const AttachmentList = ({
  attachmentList,
  approvedDocument,
}: AttachmentListProps) => {
  const hasOriginAttachment = attachmentList.some(
    (attachment) => !attachment.isAdditional,
  );
  const hasAdditionalAttachment = attachmentList.some(
    (attachment) => attachment.isAdditional,
  );

  return (
    attachmentList?.length > 0 && (
      <AttachmentListStyle>
        {hasOriginAttachment && (
          <CreateDocumentFormField
            label="첨부파일"
            style={{
              alignItems: "flex-start",
            }}
            labelStyle={{
              lineHeight: "4.6rem",
            }}
            bodyStyle={{
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
            }}
          >
            {attachmentList.map(
              (attachment) =>
                !attachment.isAdditional && (
                  <AttachmentItem
                    key={attachment.uuid}
                    url={attachment.fileUrl}
                    fileName={attachment.fileName}
                    approvedDocument={approvedDocument}
                  />
                ),
            )}
          </CreateDocumentFormField>
        )}
        {hasAdditionalAttachment && (
          <CreateDocumentFormField
            label="추가 첨부파일"
            style={{
              alignItems: "flex-start",
            }}
            labelStyle={{
              lineHeight: "4.6rem",
            }}
            bodyStyle={{
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
            }}
          >
            {attachmentList
              .filter((attachment) => attachment.isAdditional)
              .map(
                (attachment) =>
                  attachment.isAdditional && (
                    <AttachmentItem
                      key={attachment.uuid}
                      url={attachment.fileUrl}
                      fileName={attachment.fileName}
                      approvedDocument={approvedDocument}
                    />
                  ),
              )}
          </CreateDocumentFormField>
        )}
      </AttachmentListStyle>
    )
  );
};

export default DocumentDetailAttachmentList;

const AttachmentListStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
